import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-layoutsubheader',
  templateUrl: './layoutsubheader.component.html',
  styleUrls: ['./layoutsubheader.component.scss']
})
export class LayoutsubheaderComponent implements OnInit {

  @Input()
  returnButtonText : string;

  @Input()
  nextButtonText : string;
  
  @Input()
  title : string;

  @Output()
  returnButtonClick = new EventEmitter();
  @Output()
  nextButtonClick = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  goBack()
  {
    this.returnButtonClick.emit();
  }

  goNext()
  {
    this.nextButtonClick.emit();
  }

}
